import { ILaunchViewModel } from "../../components/launch/interface";




function DefaultProps(onDownloadClick?: () => void, onSkipClick?: () => void): ILaunchViewModel {
    return {
        status: {
            text: "Loading",
            fontFamily: 'Gill Sans',
            fontSize: '10vmin',
            fontAlignment: "center",
            fontWeight: 300,
            color: '#000',
            visible: false,
        },
        detail: {
            text: "",
            fontFamily: 'Gill Sans',
            fontSize: '3vmin',
            fontAlignment: "center",
            fontWeight: 300,
            color: '#000',
            visible: false,
        },
        backgroundColor: '#000',
        backgroundImage: {
            url: '',
            mode: 'cover',
        },
        centerImage: {
            url: '',
            mode: 'contain',
        },
        downloadButton: {
            text: {
                text: "Download",
                fontFamily: 'Gill Sans',
                fontSize: '8vmin',
                fontAlignment: "center",
                fontWeight: 300,
                color: '#fff',
                visible: true,
            },
            visible: false,
            backgroundColor: '#222',
            onClick: onDownloadClick ?? (() => {}),
        },
        skipButton: {
            text: {
                text: "Skip",
                fontFamily: 'Gill Sans',
                fontSize: '8vmin',
                fontAlignment: "center",
                fontWeight: 300,
                color: '#fff',
                visible: true,
            },
            visible: false,
            backgroundColor: '#222',
            onClick: onSkipClick ?? (() => {}),
        },
        progressBar: {
            progress: 0,
            backgroundColor: '#B7B7B7',
            barColor: '#3BB1DC',
            textColor: '#FFFFFF',
            visible: false,
        }
    
    };
}

export default DefaultProps;
